import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { useUIConfiguration } from '@cashier/cashier-shared';
import { Button, Loader } from '@cashier/cashier-ui';

import { useSubmitButton } from '../hooks';

import styles from './styles.module.scss';

interface FormActionProps {
  onSubmit: () => void;
  onCancel: () => void;
}

export const FormAction = ({
  onSubmit,
  onCancel,
}: FormActionProps): ReactElement => {
  const buttonBackground = useUIConfiguration('button', 'background');

  const { t } = useTranslation();
  const { isLoading, isDisabled } = useSubmitButton();

  return (
    <div className={styles.buttonContainer}>
      <div className={styles.button} data-test="confirmation-button">
        <Button
          onClick={onSubmit}
          isDisabled={isDisabled}
          type="primary"
          backgroundType={buttonBackground}
        >
          {isLoading && (
            <div className={styles.buttonLoader}>
              <Loader size="small" theme="black" />
            </div>
          )}
          {!isLoading && t('confirm.button')}
        </Button>
      </div>
      <div className={styles.button} data-test="cancel-button">
        <Button
          onClick={onCancel}
          type="primary"
          color="red"
          backgroundType={buttonBackground}
        >
          {t('cancel.button')}
        </Button>
      </div>
    </div>
  );
};
